import axios from 'axios';
import { dataEnv } from "../../config/index.js";

const API_BASE_URL = dataEnv().API_URL;

export const verifyRecaptcha = async (token, action) => {
  try {
    
    // Enviar el token y la acción al backend
    const response = await axios.post(`${API_BASE_URL}/auth/verify-recaptcha`, {
      token,
      action
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      withCredentials: true
    });

    if (!response.data.success) {
      throw new Error('Verificación de reCAPTCHA fallida');
    }

    return response.data;
  } catch (error) {
    console.error('Error verificando reCAPTCHA:', error);
    throw new Error('Error al verificar reCAPTCHA');
  }
};
